import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getInvoicesDateRequest,
  uploadInvoiceRequest,
} from "../../services/invoiceService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getInvoicesData(action) {
  try {
    const token = getToken().get("idToken");
    const { startDate, endDate } = action || {};

    const response = yield call(
      getInvoicesDateRequest,
      token,
      startDate,
      endDate
    );

    if (response[0] === 200) {
      yield put({
        type: actions.GET_INVOICES_SUCCESS,
        invoicesData: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* uploadInvoices(action) {
  try {
    const token = getToken().get("idToken");
    const { fileData, startDate, endDate } = action; // include optional dates
    const response = yield call(uploadInvoiceRequest, token, fileData);

    if (response[0] === 200) {
      // Successfully uploaded -> refresh invoices list using the same date range if provided
      yield put({
        type: actions.GET_INVOICES_REQUEST,
        startDate: startDate,
        endDate: endDate,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_INVOICES_REQUEST, getInvoicesData),
    takeEvery(actions.UPLOAD_INVOICES_REQUEST, uploadInvoices),
  ]);
}
